import { useQuery } from '@tanstack/react-query';

import * as Api from '@Api/index';
import { useDeps } from '@Contexts/DI';
import { useRequest } from '@Contexts/Request';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';

export const useYandexMerchantId = (uuid?: string) => {
  const { logger } = useDeps();
  const { region, regionId } = useRequest();
  const searchParams = new URLSearchParams({ regionId });

  if (uuid) searchParams.set('uuid', uuid);

  return useQuery({
    queryKey: ['yandex-merchant-id', region, uuid],
    queryFn: async () => {
      try {
        const url = `/backend/yandexpay/default/get-merchant-id?${searchParams.toString()}`;
        const res = await Api.queryProxi<ApiResponse<string>>(url);

        if (!res.ok) throw new BackendError(url, res);

        return res.data;
      } catch (err) {
        logger.log(err);

        return '';
      }
    },
    staleTime: Infinity,
  });
};

export default useYandexMerchantId;
